module.exports = __webpack_public_path__ + "img/docker.0ae81aca.png";